import { render, staticRenderFns } from "./drm.vue?vue&type=template&id=b885a89a&"
import script from "./drm.vue?vue&type=script&lang=js&"
export * from "./drm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a2\\Code_New\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b885a89a')) {
      api.createRecord('b885a89a', component.options)
    } else {
      api.reload('b885a89a', component.options)
    }
    module.hot.accept("./drm.vue?vue&type=template&id=b885a89a&", function () {
      api.rerender('b885a89a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sys/drm.vue"
export default component.exports